import skillMd from "../skills/create-mcp-eval/SKILL.md";
import exploreSkillMd from "../skills/explore-to-sdk-evals/SKILL.md";

export const SKILL_MD = skillMd;
export const EXPLORE_TO_SDK_EVALS_SKILL_MD = exploreSkillMd;
